import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ListingSellerStatusModel, createDateFromTimestamp, formatDateTime } from '@steelbuy/ts-shared';
import { Card, CardContentListingViewState, CardLayout } from '@steelbuy/ui-primitive';
import { getBadgeVariant } from '../status-badge-variant/StatusBadgeVariant';

type ListingDetailsStatusProps = {
    status: ListingSellerStatusModel;
    children?: ReactNode;
};

export const ListingDetailsStatus = ({ children, status: { modifiedAt, value } }: ListingDetailsStatusProps) => {
    const { t } = useTranslation('uiDomain');

    const modifiedDate = createDateFromTimestamp(modifiedAt);

    const badgeVariant = getBadgeVariant(value);
    return (
        <Card isClickable={false}>
            <CardLayout>
                <CardContentListingViewState
                    header={t(`listingDetailsStatus.header.${value}`)}
                    date={formatDateTime(modifiedDate).split(' ').join(', ')}
                    badgeVariant={badgeVariant}
                    badgeLabel={t(`listingSellerStatus.${value}`)}
                />
                {children}
            </CardLayout>
        </Card>
    );
};
